import { Subject } from 'rxjs';

export class SubjectManager {
  private static _singleton;
  private subjects: { [key: string]: Subject<any> } = {};

  static singleton = function () {
    return this._singleton || (this._singleton = SubjectManager.new());
  };

  static new() {
    return new SubjectManager().init();
  }

  init() {
    if (SubjectManager._singleton) {
      throw new Error('Use SubjectManager.singleton() instead.');
    }
    return this;
  }

  static publish(key: string, message?) {
    const subject = SubjectManager.singleton().subjects[key];
    if (subject) {
      subject.next(message);
    }
  }

  static getSubject(key: string) {
    let subject = SubjectManager.singleton().subjects[key];
    if (!subject) {
      subject = new Subject<string>();
    }
    return subject;
  }

  static setSubject(key: string, subject: Subject<any>) {
    SubjectManager.singleton().subjects[key] = subject;
  }
}
